import { FIELD__list_token } from '@shared/dto/generation/graph_invoke/_fields/_primitives/list/FIELD__list_token';
import { ENUM__token_type } from '@shared/dto/generation/graph_invoke/_fields/token/ENUM__token_type';
import { createColumnHelper } from '@tanstack/react-table';
import { useMemo } from 'react';
import { HOOK_TABLE_LAYOUT__inputs__base } from '../_base/HOOK_TABLE_LAYOUT__inputs__base';

interface PROPS {
  fields: FIELD__list_token[];
}

const helper_column = createColumnHelper<FIELD__list_token>();

export function HOOK_TABLE_LAYOUT__inputs__token_list({ fields }: PROPS) {
  /*
   *
   */

  /*
   *
   */

  const columns__additional = useMemo(
    () => [
      // Actions
      // helper_column.accessor(field => field, {
      //   id: 'actions',
      //   header: 'actions',
      //   cell: info => (
      //     <G_TABLE_CELL__inputs_images__buttons_base field={info.getValue()}>
      //       <></>
      //     </G_TABLE_CELL__inputs_images__buttons_base>
      //   ),
      // }),

      helper_column.accessor(row => row, {
        id: 'items_amount',
        header: 'Items Amount',
        cell: info => render_cell_items_amount(info.getValue()),
      }),

      // Preview
    ],
    [],
  );

  function render_cell_items_amount(field: FIELD__list_token) {
    let tokens__total = field.items.length;
    let tokens__words = field.items.filter(item => item.type == ENUM__token_type.WORD).length;
    let tokens__embeddings = field.items.filter(item => item.type == ENUM__token_type.EMBEDDING).length;
    let tokens__lora = field.items.filter(item => item.type == ENUM__token_type.LORA).length;

    let text = `${tokens__words}W + ${tokens__embeddings}E + ${tokens__lora}L = ${tokens__total}`;

    return <span className="">{text}</span>;
  }

  /*
   *
   */

  return HOOK_TABLE_LAYOUT__inputs__base({ fields, columns__additional });
}
